import React from 'react'
import './Events.scss';

export default function Events() {
  return (
    <div className='events-page-container flex-center-col'>
      <h1>Work in progress!</h1>
      <h3>Please come again later</h3>
    </div>
  )
}
